
// DUCKS pattern
import { createAction, createSlice, } from "@reduxjs/toolkit";
import { set } from "react-hook-form";
const initialState = {
    loading: true,
    error: "",
    students: [],
    current: {},
    pagination: {},
    activity: [],
    progressSummary: [],
    assessmentSummary: [],
    assignmentProgress: {},
    teacherGrades: [],
    assessmentResult: []
};
export const studentSlice = createSlice({
    name: "student",
    initialState,
    reducers: {
        setIsLoading(state, action) {
            state.loading = action.payload;
        },
        setStudents(state, action) {
            let { data } = action.payload;
            state.students = data;
            state.pagination = { ...action.payload, data: null };
            state.loading = false;
        },
        appendStudent(state, payload) {
            state.students = [...state.students, payload];
        },
        setCurrentStudent(state, action) {
            state.current = action.payload;
            state.loading = false;
        },
        setActivityStudent(state, action) {
            let data = action.payload;
            state.activity = data;
        },
        setProgressSummary(state, action) {
            let data = action.payload
            state.progressSummary = data
        },
        setAssessmentSummary(state, action) {
            let data = action.payload
            state.assessmentSummary = data
        },
        setAssignmentProgress(state, action) {
            let data = action.payload
            state.assignmentProgress = data
        },
        setTeacherGrades(state, action) {
            // let {data} = action.payload;
            state.teacherGrades = action.payload;
            state.pagination = { ...action.payload, data: null };
            state.loading = false;
        },
        setAssessmentResult(state, action){
            let data = action.payload
            state.assessmentResult = data;
        }

    },
});

export const studentActions = {
    loadStudents: createAction(`${studentSlice.name}/loadStudents`, (payload) => ({ payload })),
    loadCurrentStudent: createAction(`${studentSlice.name}/changeCurrentStudent`, (payload) => ({ payload })),
    saveCurrentStudent: createAction(`${studentSlice.name}/saveStudent`, (payload) => ({ payload })),
    createStudent: createAction(`${studentSlice.name}/createStudent`, (payload) => ({ payload })),
    loadTeacherGrade: createAction(`${studentSlice.name}/loadTeacherGrade`, (payload) => ({ payload })),
    //activity
    loadActivities: createAction(`${studentSlice.name}/loadActivities`, (payload) => ({ payload })),
    loadProgressSummary: createAction(`${studentSlice.name}/loadProgressSummary`, (payload) => ({ payload })),
    loadAssessmentSummary: createAction(`${studentSlice.name}/loadAssessmentSummary`, (payload) => ({ payload })),
    loadAssignmentProgress: createAction(`${studentSlice.name}/loadAssignmentProgress`, (payload) => ({ payload })),
    loadAssessmentResult: createAction(`${studentSlice.name}/loadAssessment`, (payload) => ({ payload })),

    setStudents: studentSlice.actions.setStudents,
    setTeacherGrades: studentSlice.actions.setTeacherGrades,
    setCurrentStudent: studentSlice.actions.setCurrentStudent,
    appendStudent: studentSlice.actions.appendStudent,
    setActivityStudent: studentSlice.actions.setActivityStudent,
    setAssessmentSummary: studentSlice.actions.setAssessmentSummary,
    setProgressSummary: studentSlice.actions.setProgressSummary,
    setAssignmentProgress: studentSlice.actions.setAssignmentProgress,
    setAssessmentResult: studentSlice.actions.setAssessmentResult


};

export const getStudents = (state) => state.student.students;
export const getTeachterGrades = (state) => state.student.teacherGrades;
export const getCurrentStudent = (state) => state.student.current;
export const getActivity = (state) => state.student.activity;
export const getProgressSummary = (state) => state.student.progressSummary;
export const getAssessmentSummary = (state) => state.student.assessmentSummary;
export const getAssignmentProgress = (state) => state.student.assignmentProgress;
export const getAssessmentResult = (state) => state.student.assessmentResult;

export const isLoading = (state) => state.student.loading;
export const getPagination = (state) => state.student.pagination;

export default studentSlice.reducer;
